/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfInternalAdminWhitelabelRequestV4SslCertificateDataOneOf, InternalAdminWhitelabelRequestV4SslCertificateDataOneOfFromJSONTyped, InternalAdminWhitelabelRequestV4SslCertificateDataOneOfToJSON, } from './InternalAdminWhitelabelRequestV4SslCertificateDataOneOf';
import { instanceOfInternalAdminWhitelabelRequestV4SslCertificateDataOneOf1, InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1FromJSONTyped, InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1ToJSON, } from './InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1';
export function InternalAdminWhitelabelRequestV4SslCertificateDataFromJSON(json) {
    return InternalAdminWhitelabelRequestV4SslCertificateDataFromJSONTyped(json, false);
}
export function InternalAdminWhitelabelRequestV4SslCertificateDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfInternalAdminWhitelabelRequestV4SslCertificateDataOneOf(json)) {
        return InternalAdminWhitelabelRequestV4SslCertificateDataOneOfFromJSONTyped(json, true);
    }
    if (instanceOfInternalAdminWhitelabelRequestV4SslCertificateDataOneOf1(json)) {
        return InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1FromJSONTyped(json, true);
    }
    return {};
}
export function InternalAdminWhitelabelRequestV4SslCertificateDataToJSON(json) {
    return InternalAdminWhitelabelRequestV4SslCertificateDataToJSONTyped(json, false);
}
export function InternalAdminWhitelabelRequestV4SslCertificateDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfInternalAdminWhitelabelRequestV4SslCertificateDataOneOf(value)) {
        return InternalAdminWhitelabelRequestV4SslCertificateDataOneOfToJSON(value);
    }
    if (instanceOfInternalAdminWhitelabelRequestV4SslCertificateDataOneOf1(value)) {
        return InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1ToJSON(value);
    }
    return {};
}
